import { ApiResponse } from 'app/types-shared';
import { RemoteAdminData } from 'app/infrastructure/remote-data';
import { SavedReportsEndpoints } from './constants';
import { SavedReportEvaluationWire } from './types';

export const api = {

  loadSavedReportEvaluation: async (endpoints: SavedReportsEndpoints, id: number): Promise<SavedReportEvaluationWire> => {
    const response = await new RemoteAdminData(endpoints.savedReportEvaluation)
      .resource<ApiResponse<SavedReportEvaluationWire[]>>()
      .filter({ id })
      .single();

    return response.data?.[0];
  },

  loadSavedReportEvaluations: async (endpoints: SavedReportsEndpoints, id: number[]): Promise<SavedReportEvaluationWire[]> => {
    const response = await new RemoteAdminData(endpoints.savedReportEvaluation)
      .resource<ApiResponse<SavedReportEvaluationWire[]>>()
      .filter({ id })
      .all();

    return response.data;
  }
};
